import {Component, forwardRef} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertAction, FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {MyreportUnscheduleAction, MyreportUnscheduleService} from "../myreport-unschedule.service";
import {firstValueFrom} from "rxjs";

/**
 * SearchAction to unschedule a myreport
 */
@Component({
    selector: "wbo-myreport-unschedule-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => MyreportUnscheduleSearchActionComponent),
            multi: true
        },
        MyreportUnscheduleService
    ]

})
export class MyreportUnscheduleSearchActionComponent implements SearchAction {

    constructor(private alertService: FUIAlertService,
                private searchModel: SearchModel<any>,
                private service: MyreportUnscheduleService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 30;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "stop-calendar";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.myreport.search.action.unschedule";
    }

    async doAction(data: any): Promise<void> {
        const action: FUIAlertAction = await firstValueFrom(this.alertService.showConfirmationOkCancel("wbo.myreport.search.prompt.unschedule.heading", "wbo.myreport.search.prompt.unschedule.message"));
        if (action === FUIAlertActions.OK_ACTION) {
            return this.service.performAction(new MyreportUnscheduleAction(data["myreportId"]));
        }
    }

    isAvailable(data: any): boolean {
        return data["isScheduled"];
    }
}
